// material
import {
  Card,
  Container,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
  IconButton
} from '@mui/material';
import { filter } from 'lodash';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import editFill from '@iconify/icons-eva/edit-fill';
import { Icon } from '@iconify/react';

//
import { useFormik } from 'formik';

import { FlightListHead, FlightListToolbar } from '../components/flightList';
// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import { ReportFilterSidebar } from '../components/sidebarFilter';
import { getReports } from '../fetch';
import { useTranslation } from '../common/LocalizationProvider';
import { EditMotionIgnitionDialog } from '../components/liveReport';
import { selectDevicesArray } from '../createSelectorUtils';

// ----------------------------------------------------------------------

const tableHeadVol = [
  { id: 'startTime', label: 'fields_StartTime', alignRight: false, display: undefined },
  { id: 'endTime', label: 'fields_EndTime', alignRight: false, display: undefined },
  { id: 'startVol', label: 'fields_StartVol', alignRight: false, display: undefined },
  { id: 'endVol', label: 'fields_EndVol', alignRight: false, display: undefined },
  { id: 'deviceName', label: 'fields_Device', alignRight: false, display: undefined },
  { id: 'duration', label: 'fields_Engine', alignRight: false, display: undefined },
  { id: 'durationVol', label: 'fields_Movement', alignRight: false, display: undefined }
];

const tableHeadRoute = [
  { id: 'id', label: 'fields_Id', alignRight: false, display: undefined },
  { id: 'fixTime', label: 'fields_Date', alignRight: false, display: undefined },
  { id: 'deviceName', label: 'fields_Device', alignRight: false, display: undefined },
  { id: 'protocol', label: 'fields_Protocol', alignRight: false, display: undefined },
  { id: 'ignition', label: 'fields_Ignition', alignRight: false, display: undefined },
  { id: 'motion', label: 'fields_Motion', alignRight: false, display: undefined },
  { id: 'sat', label: 'fields_Sat', alignRight: false, display: undefined },
  { id: 'latitude', label: 'fields_Latitude', alignRight: false, display: undefined },
  { id: 'longitude', label: 'fields_Longitude', alignRight: false, display: undefined },
  { id: 'altitude', label: 'fields_Altitude_m', alignRight: false, display: undefined },
  { id: 'elevation', label: 'fields_Elevation', alignRight: false, display: undefined },
  { id: 'speed', label: 'fields_Speed', alignRight: false, display: undefined },
  { id: '' }
];
// ----------------------------------------------------------------------
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  if (query) {
    return filter(
      array,
      (_reportResult) =>
        (_reportResult.startTime !== null &&
          moment(_reportResult.startTime)
            .format('DD/MM/YY HH:mm:ss')
            .indexOf(query.toLowerCase()) !== -1) ||
        (_reportResult.endTime !== null &&
          moment(_reportResult.endTime).format('DD/MM/YY HH:mm:ss').indexOf(query.toLowerCase()) !==
            -1) ||
        (_reportResult.startVol !== null &&
          moment(_reportResult.startVol)
            .format('DD/MM/YY HH:mm:ss')
            .indexOf(query.toLowerCase()) !== -1) ||
        (_reportResult.endVol !== null &&
          moment(_reportResult.endVol).format('DD/MM/YY HH:mm:ss').indexOf(query.toLowerCase()) !==
            -1) ||
        (_reportResult.fixTime !== null &&
          moment(_reportResult.fixTime).format('DD/MM/YY HH:mm:ss').indexOf(query.toLowerCase()) !==
            -1) ||
        (_reportResult.protocol !== null &&
          String(_reportResult.protocol).toLowerCase().indexOf(query.toLowerCase()) !== -1) ||
        (_reportResult.deviceName !== null &&
          String(_reportResult.deviceName).toLowerCase().indexOf(query.toLowerCase()) !== -1) ||
        (_reportResult.id !== null &&
          String(_reportResult.id).toLowerCase().indexOf(query.toLowerCase()) !== -1)
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function LiveReport() {
  const t = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const devices = useSelector(selectDevicesArray);
  const [tableHead, setTableHead] = useState(tableHeadRoute);

  // ----------------------------------------------------------------------

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('startTime');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPositionId, setSelectedPositionId] = useState(0);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    setPage(0);
  };
  // -------------------------------------------------------------------------
  const [reportResult, setReportResult] = useState([]);

  const [openFilter, setOpenFilter] = useState(false);
  const [openProgress, setOpenProgress] = useState(false);

  const formik = useFormik({
    initialValues: {
      group: null,
      device: null,
      period: 'today',
      from: moment().subtract(1, 'day'),
      to: moment(),
      reportType: ''
    },
    onSubmit: async (values) => {
      setOpenProgress(true);
      let selectedFrom;
      let selectedTo;
      switch (values.period) {
        case 'today':
          selectedFrom = moment().startOf('day');
          selectedTo = moment().endOf('day');
          break;
        case 'yesterday':
          selectedFrom = moment().subtract(1, 'day').startOf('day');
          selectedTo = moment().subtract(1, 'day').endOf('day');
          break;
        case 'thisWeek':
          selectedFrom = moment().startOf('week');
          selectedTo = moment().endOf('week');
          break;
        case 'previousWeek':
          selectedFrom = moment().subtract(1, 'week').startOf('week');
          selectedTo = moment().subtract(1, 'week').endOf('week');
          break;
        case 'thisMonth':
          selectedFrom = moment().startOf('month');
          selectedTo = moment().endOf('month');
          break;
        case 'previousMonth':
          selectedFrom = moment().subtract(1, 'month').startOf('month');
          selectedTo = moment().subtract(1, 'month').endOf('month');
          break;
        case 'last3Month':
          selectedFrom = moment().subtract(3, 'month').startOf('month');
          selectedTo = moment().endOf('month');
          break;
        case 'last6Month':
          selectedFrom = moment().subtract(6, 'month').startOf('month');
          selectedTo = moment().endOf('month');
          break;
        case 'thisYear':
          selectedFrom = moment().startOf('year');
          selectedTo = moment().endOf('month');
          break;
        default:
          selectedFrom = values.from.set('hour', 0).set('minute', 0).set('second', 0).utc(true);
          selectedTo = values.to.set('hour', 23).set('minute', 59).set('second', 59).utc(true);
          break;
      }

      const response = await getReports(
        values.reportType,
        values.device !== null ? values.device.id : 0,
        values.group !== null && values.device === null ? values.group.id : 0,
        0,
        selectedFrom.toISOString(),
        selectedTo.toISOString(),
        false
      );

      if (response.ok) {
        const result = await response.json();
        setReportResult(result);
        if (result.length === 0) {
          enqueueSnackbar(t('FL_Empty_Snackbar'), {
            variant: 'warning'
          });
          setRowsPerPage(10);
          setPage(0);
        }
      } else {
        setReportResult([]);
        enqueueSnackbar(t('FL_Empty_Snackbar'), {
          variant: 'warning'
        });
        setRowsPerPage(10);
        setPage(0);
      }
      setOpenFilter(false);
      setOpenProgress(false);
    }
  });
  const { resetForm, handleSubmit } = formik;

  const handleOpenFilter = () => {
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  const handleResetFilter = () => {
    resetForm();
    setReportResult([]);
    setTableHead(tableHead.map((item) => ({ ...item, display: undefined })));
    handleCloseFilter();
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - reportResult.length) : 0;

  const filteredReportTrips = applySortFilter(
    reportResult,
    getComparator(order, orderBy),
    filterName
  );

  const isReportTripNotFound = filteredReportTrips.length === 0;

  // --------------------------------------------------------------

  useEffect(() => {
    if (formik.values.reportType === 'route') {
      setReportResult([]);
      setOrderBy('fixTime');
      setTableHead(tableHeadRoute);
    } else {
      setReportResult([]);
      setOrderBy('startTime');
      setTableHead(tableHeadVol);
    }
  }, [formik.values.reportType]);
  // --------------------------------------------------------------

  return (
    <Page title={t('liveReport_Title')} openProgress={openProgress}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0}>
          <Typography variant="h4" gutterBottom>
            {t('liveReport')}
          </Typography>
        </Stack>

        <Stack
          direction="row"
          flexWrap="wrap-reverse"
          alignItems="center"
          justifyContent="flex-end"
          sx={{ mb: 5 }}
        >
          <Stack direction="row" spacing={1} flexShrink={0} sx={{ my: 1 }}>
            <ReportFilterSidebar
              formik={formik}
              isOpenFilter={openFilter}
              onResetFilter={handleResetFilter}
              onOpenFilter={handleOpenFilter}
              onCloseFilter={handleCloseFilter}
              onSaveFilter={handleSubmit}
              clubFilter
              deviceFilter
              userFilter={false}
            />
          </Stack>
        </Stack>

        <Card>
          <FlightListToolbar filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 300 }}>
              <Table>
                <FlightListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={tableHead}
                  rowCount={reportResult.length}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {filteredReportTrips
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      if (formik.values.reportType === 'route') {
                        const {
                          id,
                          fixTime,
                          deviceId,
                          protocol,
                          latitude,
                          longitude,
                          altitude,
                          speed,
                          attributes
                        } = row;
                        const deviceName =
                          devices.find((device) => device.id === deviceId).name || '';

                        return (
                          <TableRow hover key={index}>
                            <TableCell component="th" scope="row">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography variant="subtitle2" noWrap>
                                  {id}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography variant="subtitle2" noWrap>
                                  {moment(fixTime).format('DD/MM/YY HH:mm:ss')}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography variant="subtitle2" noWrap>
                                  {deviceName}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography variant="subtitle2" noWrap>
                                  {protocol}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography variant="subtitle2" noWrap>
                                  {attributes && attributes.ignition ? 'true' : 'false'}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography variant="subtitle2" noWrap>
                                  {attributes && attributes.motion ? 'true' : 'false'}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography variant="subtitle2" noWrap>
                                  {attributes && attributes.sat}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography variant="subtitle2" noWrap>
                                  {latitude}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography variant="subtitle2" noWrap>
                                  {longitude}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography variant="subtitle2" noWrap>
                                  {altitude}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography variant="subtitle2" noWrap>
                                  {attributes && attributes.elevation}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography variant="subtitle2" noWrap>
                                  {speed}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell align="right">
                              <IconButton
                                onClick={() => {
                                  setSelectedPositionId(id);
                                  setIsOpen(true);
                                }}
                              >
                                <Icon icon={editFill} width={24} height={24} />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      }
                      const {
                        startTime,
                        endTime,
                        startVol,
                        endVol,
                        deviceId,
                        duration,
                        durationVol
                      } = row;
                      const deviceName =
                        devices.find((device) => device.id === deviceId).name || '';
                      return (
                        <TableRow hover key={index}>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{ display: tableHead[0].display }}
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {moment(startTime).format('DD/MM/YY HH:mm:ss')}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{ display: tableHead[0].display }}
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {moment(endTime).format('DD/MM/YY HH:mm:ss')}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{ display: tableHead[0].display }}
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {moment(startVol).format('DD/MM/YY HH:mm:ss')}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{ display: tableHead[0].display }}
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {moment(endVol).format('DD/MM/YY HH:mm:ss')}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {deviceName}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {`${Math.round(duration / 60000)} min`}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell component="th" scope="row">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {`${Math.round(durationVol / 60000)} min`}
                              </Typography>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={9} />
                    </TableRow>
                  )}
                </TableBody>
                {isReportTripNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={9} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[10, 50, 100, 250, 500]}
            component="div"
            count={filteredReportTrips.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
        {isOpen && (
          <EditMotionIgnitionDialog
            positionId={selectedPositionId}
            route={reportResult.find((r) => r.id === selectedPositionId) || {}}
            refresh={() => handleSubmit()}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />
        )}
      </Container>
    </Page>
  );
}
